import { Box, Grid } from '@mui/material';
import { GuidoBanner } from '../guidoBanner';
import { useEffect, useState } from 'react';

interface PropsContainer {
    children?: any;
    title?: string;
}

export const ContainerWebChat = ({ children }: PropsContainer) => {
    const [isEmbedded, setIsEmbedded] = useState(false);

    useEffect(() => {
        const inIframe =
            typeof window !== 'undefined' && window.self !== window.top;
        const embedParam =
            typeof window !== 'undefined' &&
            new URLSearchParams(window.location.search).get('embed') === '1';
        setIsEmbedded(inIframe || embedParam);
    }, []);

    const outerSx = isEmbedded
        ? {
            width: '100%',
            maxWidth: 'none',
            m: 0,
            p: 0,
            bgcolor: 'transparent',
            borderRadius: 0,
            boxShadow: 'none',
        }
        : {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: { xs: 1.5, sm: 2.5 },
            py: { xs: 2, sm: 3 },
            bgcolor: 'transparent',
        };

    const panelSx = isEmbedded
        ? {
            width: '100%',
            bgcolor: '#fff',
            borderRadius: 2,
            boxShadow: 'none',
        }
        : {
            width: {
                xs: '92vw',
                sm: 'min(92vw, clamp(360px, calc((100vh - 64px) * (9 / 16)), 640px))',
            },
            mx: 'auto',
            bgcolor: '#fff',
            borderRadius: 2,
            boxShadow: '0 10px 30px rgba(0,0,0,.08)',
        };

    return (
        <Box sx={outerSx}>
            <Box sx={panelSx}>
                <Grid
                    id="chat-web-container"
                    className="container-crmware-previsora-chat-form"
                >
                    <Grid className="container crmware-previsora-form">
                        <GuidoBanner />
                        <Grid className="crmware-previsora-container-form">
                            <Box sx={{ width: '100%' }}>
                                <Grid className="crmware-previsora-chat-wecallyou-containter">
                                    {children}
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
